module.exports = [
    '$templateCache',
function (
    $templateCache
) {
    $templateCache.put('uib/template/pagination/pagination.html', require('./uib-pagination.html'));
}];
